.settings {
  .removeSpellsButton {
    margin: 16px 0;

    svg {
      fill: var(--color-accent);
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      margin-right: 8px;
    }
  }

  h4,
  h5 {
    margin-bottom: 8px;
    margin-top: 32px;
    font-size: 16px;
  }

  .selectLabel {
    display: block;
    margin-top: 16px;
    margin-bottom: 4px;
    font-weight: bold;
    font-size: 14px;
  }

  ul {
    padding: 0;
    margin: 0;
  }
}
